import { render } from "./PraticeOtto.vue?vue&type=template&id=b7e44992&scoped=true&ts=true"
import script from "./PraticeOtto.vue?vue&type=script&lang=ts"
export * from "./PraticeOtto.vue?vue&type=script&lang=ts"

import "./PraticeOtto.vue?vue&type=style&index=0&id=b7e44992&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e44992"]])

export default __exports__